import React from 'react';

const PEInvestorMatchSection = () => (
    <section className="lp-pe-im">
        <div className="lp-pe-im-inner">
            <span className="lp-pe-eyebrow lp-pe-eyebrow--dark" data-lp-reveal>For Investors</span>
            <h2 className="lp-pe-h2 is-dark" data-lp-reveal data-lp-delay="60">Diligentsia InvestorMatch</h2>
            <p data-lp-reveal data-lp-delay="120">Register your fund for free on Diligentsia InvestorMatch, to be matched with qualified diligenced opportunities meeting your investment criteria, and secondary opportunities from the other 50 VCs/PEs already on InvestorMatch.</p>
        </div>
    </section>
);

export default PEInvestorMatchSection;
